import counter from './counter'
import icon from './icon'

function registerAll() {
  counter.register()
  icon.register()
}

registerAll()
